export async function nativeShare(
  url: string,
  title: string,
  text?: string,
): Promise<'shared' | 'cancelled' | 'unsupported'> {
  if (typeof navigator === 'undefined' || typeof navigator.share !== 'function') {
    return 'unsupported';
  }
  try {
    await navigator.share({ url, title, text: text ?? title });
    return 'shared';
  } catch {
    return 'cancelled';
  }
}

export async function copyToClipboard(text: string): Promise<boolean> {
  try {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(text);
      return true;
    }
  } catch {
    /* fallthrough */
  }
  try {
    const ta = document.createElement('textarea');
    ta.value = text;
    ta.style.position = 'fixed';
    ta.style.opacity = '0';
    document.body.appendChild(ta);
    ta.select();
    const ok = document.execCommand('copy');
    document.body.removeChild(ta);
    return ok;
  } catch {
    return false;
  }
}

export function whatsappLink(url: string, title: string): string {
  return `https://wa.me/?text=${encodeURIComponent(`${title}: ${url}`)}`;
}

export function smsLink(url: string, title: string): string {
  return `sms:?&body=${encodeURIComponent(`${title}: ${url}`)}`;
}

export function emailLink(url: string, title: string): string {
  return `mailto:?subject=${encodeURIComponent(title)}&body=${encodeURIComponent(
    `${title}\n\n${url}`,
  )}`;
}
